<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-02-11 09:00:00
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2026-02-11 09:00:00
 * @FilePath: \goodmanger\src\views\GoodsTypeManagement.vue
 * @Description: 商品类型管理页面
-->
<template>
  <div class="goods-type-management">
    <div class="page-header">
      <h2>商品类型管理</h2>
      <el-button type="primary" @click="handleAddType">添加商品类型</el-button>
    </div>
    
    <!-- <div class="search-box">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="类型名称">
          <el-input v-model="searchForm.name" placeholder="请输入类型名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div> -->
    
    <el-table :data="typeList" style="width: 100%">
      <el-table-column prop="id" label="类型ID" width="100"></el-table-column>
      <el-table-column prop="commodity_type" label="类型名称"></el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="handleEditType(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="handleDeleteType(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    
    <!-- 添加/编辑商品类型对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="400px">
      <el-form :model="typeForm" :rules="rules" ref="typeForm">
        <el-form-item label="类型名称" prop="commodity_type">
          <el-input v-model="typeForm.commodity_type" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'GoodsTypeManagement',
  data() {
    return {
      activeMenu: '/goods-type-management',
      searchForm: {
        name: ''
      },
      typeList: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      dialogTitle: '添加商品类型',
      typeForm: {
        id: '',
        commodity_type: ''
      },
      rules: {
        commodity_type: [
          { required: true, message: '请输入类型名称', trigger: 'blur' }
        ]
      }
    };
  },
  mounted() {
    this.getTypeData();
  },
  methods: {
    getTypeData() {
      axios.get('https://www.moodsci.com/pigbox/CommodityService/queryJianZuGoodsType')
        .then((res) => {
          console.log('商品类型数据:', res.data);
          this.typeList = res.data;
          this.total = res.data.length;
        })
        .catch(error => {
          console.error('获取商品类型失败:', error);
          this.$message({ type: 'error', message: '获取商品类型失败，请重试' });
        });
    },
    handleSearch() {
      // 搜索逻辑
      console.log('搜索商品类型:', this.searchForm);
      
      // 构建搜索关键字
      let searchText = this.searchForm.name;
      
      // 调用搜索接口（如果有）
      // 暂时使用本地筛选
      let filteredList = this.typeList;
      if (searchText) {
        const searchName = searchText.toLowerCase();
        filteredList = filteredList.filter(item => 
          item.commodity_type.toLowerCase().includes(searchName)
        );
      }
      
      // 更新类型列表和总数
      this.typeList = filteredList;
      this.total = filteredList.length;
    },
    resetForm() {
      this.searchForm = {
        name: ''
      };
      // 重置表单后重新加载所有商品类型数据
      this.getTypeData();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      console.log(`每页 ${size} 条`);
    },
    handleCurrentChange(current) {
      this.currentPage = current;
      console.log(`当前页: ${current}`);
    },
    handleAddType() {
      this.dialogTitle = '添加商品类型';
      this.typeForm = {
        id: '',
        commodity_type: ''
      };
      this.dialogVisible = true;
    },
    handleEditType(row) {
      this.dialogTitle = '编辑商品类型';
      this.typeForm = { ...row };
      this.dialogVisible = true;
    },
    handleDeleteType(id) {
      this.$confirm('确定要删除此商品类型吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除商品类型 - 调用接口
        const apiUrl = `https://www.moodsci.com/pigbox/CommodityService/deteleJianZuGoodsType/${id}`;
        
        axios.post(apiUrl)
          .then(response => {
            console.log('删除商品类型接口响应:', response);
            // 接口调用成功后，重新获取商品类型数据
            this.getTypeData();
            this.$message({ type: 'success', message: '删除成功' });
          })
          .catch(error => {
            console.error('删除商品类型接口调用失败:', error);
            this.$message({ type: 'error', message: '删除失败，请重试' });
          });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消删除' });
      });
    },
    handleSubmit() {
      this.$refs.typeForm.validate((valid) => {
        if (valid) {
          if (this.typeForm.id) {
            // 编辑商品类型 - 调用接口
            const apiUrl = `https://www.moodsci.com/pigbox/CommodityService/updateJianZuGoodsType?id=${this.typeForm.id}&goods=${encodeURIComponent(this.typeForm.commodity_type)}`;
            
            axios.post(apiUrl)
              .then(response => {
                console.log('编辑商品类型接口响应:', response);
                // 接口调用成功后，重新获取商品类型数据
                this.getTypeData();
                this.dialogVisible = false;
                this.$message({ type: 'success', message: '编辑成功' });
              })
              .catch(error => {
                console.error('编辑商品类型接口调用失败:', error);
                this.$message({ type: 'error', message: '编辑失败，请重试' });
              });
          } else {
            // 添加商品类型 - 调用接口
            const apiUrl = `https://www.moodsci.com/pigbox/CommodityService/addJianZuGoodsType?goods=${this.typeForm.commodity_type}`;
          
            
            axios.post(apiUrl)
              .then(response => {
                console.log('添加商品类型接口响应:', response);
                // 接口调用成功后，重新获取商品类型数据
                this.getTypeData();
                this.dialogVisible = false;
                this.$message({ type: 'success', message: '添加成功' });
              })
              .catch(error => {
                console.error('添加商品类型接口调用失败:', error);
                this.$message({ type: 'error', message: '添加失败，请重试' });
              });
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.goods-type-management {
  padding: 20px;
  background-color: #f5f5f5;
  height: 100%;
  overflow-y: auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
}

.search-box {
  background-color: white;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.el-table {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>